import React from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useLocation } from 'react-router-dom';

const TBODetail = ({ i }) => {
	const location = useLocation();
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('xs'));
	return (
		<Box
			style={{
				boxShadow: '0 0 10px rgba(0,0,0,.3)',
				backgroundColor: '#FFF',
				marginTop: 20,
				// padding: 10,
			}}>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box
					style={{
						display: 'flex',
						alignItems: 'center',
					}}>
					<img
						src={`https://nitish.musafirbazar.com/static/media/${i.Airline.AirlineCode}.gif`}
						style={{ height: 35 }}
					/>
					<span style={{ fontSize: 14, marginLeft: 10 }}>
						{`${i.Airline.AirlineName} ${i.Airline.AirlineCode}-${i.Airline.FlightNumber}`}
					</span>
				</Box>
				<span>{`${i.Origin.Airport.CityName} to ${i.Destination.Airport.CityName}`}</span>
			</Box>

			<Box
				style={{
					padding: 20,
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
				}}>
				<Box>
					<Box style={{ display: 'flex', alignItems: 'center' }}>
						<h1 style={{ fontSize: matches ? 16 : 26 }}>
							{i.Origin.Airport.AirportCode}
						</h1>
						<span
							style={{
								fontSize: matches ? 16 : '24px',
								marginLeft: '12px',
							}}>
							{i.Origin.DepTime.split('T')[1]}
						</span>
					</Box>
					<Box>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Origin.DepTime.split('T')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Origin.Airport.AirportName}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Origin.Airport.CityName}
						</span>
					</Box>
				</Box>
				<Box>
					<Box style={{ alignItems: 'center', textAlign: 'center' }}>
						<AccessTimeIcon />
						<h2>2hr 30mn</h2>
					</Box>
				</Box>
				<Box>
					<Box
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}>
						<h1 style={{ fontSize: matches ? 16 : 26 }}>
							{i.Destination.Airport.AirportCode}
						</h1>
						<span
							style={{
								fontSize: matches ? 16 : '24px',
								marginLeft: '12px',
							}}>
							{i.Destination.ArrTime.split('T')[1]}
						</span>
					</Box>
					<Box style={{ textAlign: 'end' }}>
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Destination.ArrTime.split('T')[0]}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Destination.Airport.AirportName}
						</span>
						<br />
						<span style={{ fontSize: 12, color: 'grey' }}>
							{i.Destination.Airport.CityName}
						</span>
					</Box>
				</Box>
			</Box>
			<Box
				style={{
					backgroundColor: '#E1E1E1',
					color: 'rgba(0,0,0,.64)',
					padding: 10,
					display: 'flex',
					justifyContent: 'space-between',
				}}>
				<Box>
					<span style={{ fontSize: 14 }}>BAGGAGE</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${i.Origin.Airport.AirportCode} to ${i.Destination.Airport.AirportCode}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CHECK-IN </span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${i.Baggage}`}</span>
				</Box>
				<Box>
					<span style={{ fontSize: 14 }}>CABIN</span>
					<br />
					<span
						style={{
							fontSize: 16,
							color: 'black',
						}}>{`${i.CabinBaggage}`}</span>
				</Box>
			</Box>
		</Box>
	);
};

export default TBODetail;
